import { Component, ElementRef, forwardRef, Input, SimpleChanges, ViewChild } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
  selector: "ds-checkbox",
  templateUrl: "./ds-checkbox.component.html",
  styleUrls: ["./ds-checkbox.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DsCheckboxComponent),
      multi: true,
    },
  ],
})
export class DsCheckboxComponent implements ControlValueAccessor {
  @Input() name: string = "";
  @Input() value: string = "";
  @Input() indeterminate: boolean = false;
  @Input() label: string = "";
  @Input() disabled: boolean = false;
  @Input() error: boolean = false;
  @Input() errorMessage: string = "";
  @ViewChild("checkboxInput") checkboxRef!: ElementRef<HTMLInputElement>;

  private _checked: boolean = false;
  private onChange = (value: boolean) => {};
  private onTouched = () => {};
  constructor() {}

  ngAfterViewInit() {
    this.evaluateIndeterminate();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["indeterminate"]) {
      this.evaluateIndeterminate();
    }
  }

  evaluateIndeterminate() {
    if (this.indeterminate && this.checkboxRef) {
      const checkBox = this.checkboxRef.nativeElement;
      checkBox.checked = false;
      checkBox.indeterminate = true;
    }
  }

  get checked(): boolean {
    return this._checked;
  }

  @Input() set checked(value: boolean) {
    this._checked = value;
    this.onChange(value);
  }

  writeValue(value: boolean): void {
    this._checked = value;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onCheckboxChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.checked = target.checked;
    this.onTouched();
  }
}
